import React from 'react';
import { AdminRouteName } from '../../CONSTANTS';
import CustomerTableRecords from '../CustomerTableRecords';

const AllCustomers = () => (
  <CustomerTableRecords defaultUrl={AdminRouteName.customersRoute} toggleStorageId="all_customer-table-col" hasNameAndImage permissionName="can-view-all-customers" />
);
export default AllCustomers;
